import React from "react";
import { HeartHandshake, ShieldAlert, Ban, Link2Off, Eye, Scale } from "lucide-react";

export const GUIDELINES = [
  { icon: HeartHandshake, title: "Be kind and respectful", body: "Disagree with ideas, not people. No harassment, bullying, threats or targeting anyone for who they are." },
  { icon: Ban, title: "No hate or violence", body: "Hate speech, slurs, glorifying violence or encouraging self-harm are removed and may lead to a ban." },
  { icon: Eye, title: "Keep it safe for everyone", body: "No nudity, sexual content involving minors, graphic gore or non-consensual images." },
  { icon: Link2Off, title: "No spam or scams", body: "No fake giveaways, crypto schemes, follower selling or repeated posts. New accounts can share links once verified." },
  { icon: ShieldAlert, title: "Be real", body: "Don't impersonate people or brands, and don't spread content you know is false and harmful." },
  { icon: Scale, title: "Respect privacy and the law", body: "Never share someone's private information. Illegal content and activity are not allowed." },
];

export const GuidelinesContent = ({ compact = false }) => (
  <div data-testid="guidelines-content" className={compact ? "space-y-3" : "space-y-4"}>
    {GUIDELINES.map((g, i) => (
      <div key={g.title} className="flex gap-3">
        <div className="w-9 h-9 shrink-0 rounded-xl bg-[#6C0BA9]/20 border border-[#6C0BA9]/40 flex items-center justify-center">
          <g.icon className="w-4 h-4 text-[#C084FC]" />
        </div>
        <div>
          <div className="text-sm font-semibold">{i + 1}. {g.title}</div>
          <p className="text-xs text-muted-foreground leading-relaxed mt-0.5">{g.body}</p>
        </div>
      </div>
    ))}
    <p className="text-xs text-muted-foreground border-t border-border pt-3">
      Anyone can report a post, comment, message or account. Our moderators review reports and may remove content or suspend accounts that break these rules.
    </p>
  </div>
);
